import { RootState } from 'store';

export const selectAppointmentActivities = ({ appointments }: RootState) => appointments.activities.rows;
